import { Separator } from '@betterment/samba-react';

import { getAccountHolderNames } from '../../../../Shared/accountHolders';
import { BorderedBox } from '../BorderedBox';
import { BoxTitle } from '../BoxTitle';
import { PurchaseOrderAccountHoldingsQuery } from '../graphql/query.purchaseOrderaccountHoldings.generated';
import { SaleDetailsRow } from '../SaleDetailsRow';
import { formatAccountNameForReview } from '../utils';

interface AccountDetailsLoadedProps {
  account: PurchaseOrderAccountHoldingsQuery['managedAccount'];
  subAccountName: string;
}

export const AccountDetailsLoaded: React.FC<AccountDetailsLoadedProps> = ({ account, subAccountName }) => {
  const accountDisplayName = formatAccountNameForReview(
    account.name,
    account.envelope.purpose?.name,
    subAccountName,
    account.isTaxCoordinated
  );
  const clientNames = getAccountHolderNames(account);

  return (
    <BorderedBox>
      <BoxTitle>Account details</BoxTitle>
      <Separator />
      <SaleDetailsRow>
        <SaleDetailsRow.Label>Client</SaleDetailsRow.Label>
        <SaleDetailsRow.Value>{clientNames}</SaleDetailsRow.Value>
      </SaleDetailsRow>
      <Separator />
      <SaleDetailsRow>
        <SaleDetailsRow.Label>Account</SaleDetailsRow.Label>
        <SaleDetailsRow.Value>{accountDisplayName}</SaleDetailsRow.Value>
      </SaleDetailsRow>
    </BorderedBox>
  );
};
